module.exports = __webpack_public_path__ + "img/icon_meta.87cef171.png";